<template>
  <div>
    <div>
      <div v-if="loading" class="text-center" style="margin-top: 88px">
        <Loading></Loading>
      </div>
      <v-container
        v-else
        class="Kanit px-5"
        grid-list-xs
        style="padding-bottom: 100px"
      >
        <div>
          <div style="text-align: center" class="py-2 mb-2">
            <img style="height: 50%; width: 64px" src="../assets/logo.svg" />
          </div>
        </div>
        <div class="text-center mb-4">
          <h3>กรอกข้อมูลช่างทาสี</h3>
        </div>
        <div>
          <ValidationObserver ref="observer" tag="form">
            <form>
              <ValidationProvider
                :name="'Email'"
                :rules="'required|email'"
                key="Email"
                v-slot="{ errors, valid }"
              >
                <v-text-field
                  large
                  class="mb-0"
                  outlined
                  name="email"
                  @input="input.email = removeHiddenSpace($event)"
                  v-model="input.email"
                  placeholder="Email"
                  :error-messages="errors"
                  :valid="valid"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider
                :name="'ชื่อจริง'"
                :rules="'required'"
                key="firstname"
                v-slot="{ errors, valid }"
              >
                <v-text-field
                  large
                  class="mb-0"
                  outlined
                  @input="input.first_name = removeHiddenSpace($event)"
                  v-model="input.first_name"
                  placeholder="ชื่อจริง"
                  :error-messages="errors"
                  :valid="valid"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider
                :name="'นามสกุล'"
                :rules="'required'"
                key="lastname"
                v-slot="{ errors, valid }"
              >
                <v-text-field
                  large
                  class="mb-0"
                  outlined
                  v-model="input.last_name"
                  @input="input.last_name = removeHiddenSpace($event)"
                  placeholder="นามสกุล"
                  :error-messages="errors"
                  :valid="valid"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider
                :name="'เบอร์โทร'"
                :rules="'required'"
                key="Phoneno"
                v-slot="{ errors, valid }"
              >
                <v-text-field
                  large
                  class="mb-0"
                  outlined
                  type="number"
                  v-model="input.phoneno"
                  placeholder="เบอร์โทร"
                  :error-messages="errors"
                  :valid="valid"
                ></v-text-field>
              </ValidationProvider>

              <div>
                <div style="font-weight: 600; font-size: 19px">
                  กรุณายืนยันตัวตน
                </div>
                <div style="color: red; font-style: italic; font-size: 0.8em">
                  *ถ่ายรูปหน้าตรงพร้อมกับถือบัตรประชาชนของคุณ*
                </div>
                <div class="mb-2" style="font-size: 0.7em">
                  โปรดถ่ายรูปหน้าตรงพร้อมถือบัตรประชาชนของคุณ
                  โดยเห็นหน้าและรูปบัตรประชาชนอย่างชัดเจน
                </div>
                <ValidationProvider
                  :name="'รูปภาพ'"
                  :rules="'required'"
                  key="photo"
                  v-slot="{ errors }"
                >
                  <upload-single-file
                    v-model="input.identity_verification"
                    :max="10"
                    data-vv-name="uploadMultipleFile"
                    data-vv-as="Preview Image"
                  ></upload-single-file>
                  <div
                    style="color: red; font-size: small"
                    v-if="errors.length"
                  >
                    {{ errors[0] }}
                  </div>
                </ValidationProvider>
              </div>
              <div class="mt-4">
                <div
                  style="border-bottom: 1.2px solid #3086d2; font-weight: 600"
                >
                  ทักษะที่สามารถรับงานได้
                </div>
                <div>
                  <div class="mt-3" style="font-size: small; font-weight: bold">
                    ประเภทงานทาสี
                  </div>
                  <!-- <v-radio-group
                    hide-details
                    v-model="input.experience"
                    row
                    class="smallCheckbox mt-1"
                  >
                    <v-radio label="ทาสีภายใน/ภายนอก" value="ทาสีภายใน/ภายนอก"></v-radio>
                    <v-radio label="ทาสีหลังคา" value="ทาสีหลังคา"></v-radio>
                    <v-radio label="ทาสีตึกสูง" value="ทาสีตึกสูง"></v-radio>
                    <v-radio label="ทาสีตกแต่งพิเศษ" value="ทาสีตกแต่งพิเศษ"></v-radio>
                    <v-radio label="ทาสีงานไม้" value="ทาสีงานไม้"></v-radio>
                  </v-radio-group>-->
                  <v-row class="smallCheckbox mx-2">
                    <v-checkbox
                      small
                      hide-details
                      v-model="input.experience"
                      label="ทาสีภายใน/ภายนอก"
                      value="ทาสีภายใน/ภายนอก"
                    ></v-checkbox>
                    <v-checkbox
                      small
                      hide-details
                      v-model="input.experience"
                      label="ทาสีหลังคา"
                      value="ทาสีหลังคา"
                    ></v-checkbox>
                    <v-checkbox
                      small
                      hide-details
                      v-model="input.experience"
                      label="ทาสีตึกสูง"
                      value="ทาสีตึกสูง"
                    ></v-checkbox>
                    <v-checkbox
                      small
                      hide-details
                      v-model="input.experience"
                      label="ทาสีตกแต่งพิเศษ"
                      value="ทาสีตกแต่งพิเศษ"
                    ></v-checkbox>
                    <v-checkbox
                      small
                      hide-details
                      v-model="input.experience"
                      label="ทาสีงานไม้"
                      value="ทาสีงานไม้"
                    ></v-checkbox>
                  </v-row>
                </div>

                <div>
                  <div class="mt-1" style="font-size: small; font-weight: bold">
                    อื่นๆ
                  </div>
                  <!-- <v-radio-group
                    hide-details
                    v-model="input.experience"
                    row
                    class="smallCheckbox mt-1"
                  >
                    <v-radio label="ปูกระเบื้อง" value="ปูกระเบื้อง"></v-radio>
                    <v-radio label="ติดตั้งฝ้าเพดาน และผนัง" value="ติดตั้งฝ้าเพดาน และผนัง"></v-radio>
                    <v-radio label="ติดตั้งระบบกันซึม" value="ติดตั้งระบบกันซึม"></v-radio>
                    <v-radio label="ทำระบบพื้นโรงงานอุตสาหกรรม" value="ทำระบบพื้นโรงงานอุตสาหกรรม"></v-radio>
                  </v-radio-group>-->
                  <v-row class="smallCheckbox mx-2">
                    <v-checkbox
                      small
                      hide-details
                      v-model="input.experience"
                      label="ปูกระเบื้อง"
                      value="ปูกระเบื้อง"
                    ></v-checkbox>
                    <v-checkbox
                      small
                      hide-details
                      v-model="input.experience"
                      label="ติดตั้งฝ้าเพดาน และผนัง"
                      value="ติดตั้งฝ้าเพดาน และผนัง"
                    ></v-checkbox>
                    <v-checkbox
                      small
                      hide-details
                      v-model="input.experience"
                      label="ติดตั้งระบบกันซึม"
                      value="ติดตั้งระบบกันซึม"
                    ></v-checkbox>
                    <v-checkbox
                      small
                      hide-details
                      v-model="input.experience"
                      label="ทำระบบพื้นโรงงานอุตสาหกรรม"
                      value="ทำระบบพื้นโรงงานอุตสาหกรรม"
                    ></v-checkbox>
                  </v-row>
                </div>
                <div
                  class="v-messages__message"
                  style="color: red; font-size: small; margin-top: 6px"
                  v-if="experienceerror"
                >
                  {{ experienceerror }}
                </div>
              </div>
              <div
                style="border-bottom: 1.2px solid #3086d2; font-weight: 600"
                class="mb-5 mt-4"
              >
                สถานที่งาน
              </div>
              <ValidationProvider
                :name="'รหัสไปรษณีย์'"
                :rules="'required'"
                key="zipcode"
                v-slot="{ errors }"
              >
                <thai-address-input
                  v-model="input.zip_code"
                  type="zipcode"
                  @select="onSelectAddress"
                  :placeholder="`รหัสไปรษณีย์`"
                  :error-messages="errors"
                  :hide-details="errors.length == 0"
                ></thai-address-input>
              </ValidationProvider>
              <div style="clear: both"></div>
              <ValidationProvider
                :name="'จังหวัด'"
                :rules="'required'"
                key="province"
                v-slot="{ errors }"
              >
                <thai-address-input
                  v-model="input.province"
                  type="province"
                  placeholder="จังหวัด"
                  @select="onSelectAddress"
                  :error-messages="errors"
                  :hide-details="errors.length == 0"
                ></thai-address-input>
              </ValidationProvider>
              <div style="clear: both"></div>

              <ValidationProvider
                :name="'อำเภอ/เขต'"
                :rules="'required'"
                key="amphoe"
                v-slot="{ errors }"
              >
                <thai-address-input
                  v-model="input.sub_district"
                  type="amphoe"
                  placeholder="อำเภอ/เขต"
                  @select="onSelectAddress"
                  :error-messages="errors"
                  :hide-details="errors.length == 0"
                ></thai-address-input>
              </ValidationProvider>
              <div style="clear: both"></div>
              <ValidationProvider
                :name="'ตำบล/แขวง'"
                :rules="'required'"
                key="district"
                v-slot="{ errors }"
              >
                <thai-address-input
                  v-model="input.district"
                  type="district"
                  placeholder="ตำบล/แขวง"
                  @select="onSelectAddress"
                  :error-messages="errors"
                  :hide-details="errors.length == 0"
                ></thai-address-input>
              </ValidationProvider>
              <div style="clear: both"></div>
              <ValidationProvider
                :name="'ที่อยู่'"
                :rules="'required'"
                key="address"
                v-slot="{ errors, valid }"
              >
                <v-textarea
                  large
                  class="mb-0"
                  outlined
                  rows="4"
                  v-model="input.address1"
                  placeholder="รายละเอียดที่อยู่ บ้านเลขที่ หมู่บ้าน"
                  :error-messages="errors"
                  :valid="valid"
                ></v-textarea>
              </ValidationProvider>
            </form>
          </ValidationObserver>
        </div>

        <div @click="checkFeyvery" v-ripple class="addcartbtn Kanit myshadow">
          <p v-if="!saveloading">ยืนยัน</p>
          <div v-else>
            <v-progress-circular
              indeterminate
              size="35"
              color="white"
            ></v-progress-circular>
          </div>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import UploadSingleFile from "@/components/UploadSingleFile.vue";
import ThaiAddressInput from "@/components/ThaiAddressInput";
import axios from "axios";
import Loading from "@/components/Loading.vue";
export default {
  components: {
    Loading,
    UploadSingleFile,
    ThaiAddressInput,
  },
  data() {
    return {
      loading: true,
      saveloading: false,
      orderid: "",
      experienceerror: "",
      input: {
        first_name: "",
        last_name: "",
        email: "",
        phoneno: "",
        zip_code: "",
        province: "",
        sub_district: "",
        district: "",
        address1: "",
        experience: [],
        identity_verification: "",
      },
    };
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
    experienceinput() {
      return this.input.experience;
    },
  },
  async mounted() {
    this.loading = true;
    await this.checkLoginStatus();
    await this.checkRegisterStatus();

    await this.getForm();
    this.loading = false;
  },
  methods: {
    removeReddot(e) {
      this.input.email = this.removeHiddenSpace(e);
    },
    checkFeyvery() {
      var vm = this;
      return new Promise(async (resolve) => {
        if (!this.saveloading) {
          var isValid = await this.$refs.observer.validate();
          if (!this.input.experience.length)
            this.experienceerror = "กรุณาเลือกทักษะที่สามารถรับงานได้";
          if (isValid && this.input.experience) {
            vm.saveloading = true;

            axios
              .get(
                "https://communitybotbyzwizai.herokuapp.com/toacheckusersfeyverly",
                {
                  headers: { AUTHORIZATION: "Bearer xxx xxx" },
                  params: {
                    phoneno: vm.input.phoneno,
                  },
                }
              )
              .then(async (response) => {
                vm.saveloading = false;
                if (response.data.responsecode == 200) {
                  var data = {
                    ...vm.input,
                    userid: this.$store.state.userid,
                    apptype: this.query.apptype,
                    pageid: vm.query.pageid,
                  };

                  vm.$store.state.registerData = data;

                  if (response.data.data[0].status) {
                    // true
                    vm.$store.state.registerType = "painter";
                    vm.query.view = "Login";
                  } else {
                    vm.$store.state.registerType = "painter";
                    vm.query.view = "OTP";
                  }
                } else {
                  await vm.$swal.fire({
                    icon: "error",
                    text: response.data.reason,
                    confirmButtonText: "ตกลง",
                  });
                  resolve();
                }
              });
          }
        }
      });
    },
    checkRegisterStatus() {
      return new Promise((resolve) => {
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toacheckusersregister",
            {
              params: {
                userid: this.$store.state.userid,
                apptype: this.query.apptype,
                pageid: this.query.pageid,
              },
              headers: {
                AUTHORIZATION: "Bearer xxx xxx ",
              },
            }
          )
          .then((response) => {
            if (response.data.responsecode == 200) {
              if (response.data.data[0].status) {
                //เคยสมัคร
                this.query.view = "Agreement";
                resolve();
              } else {
                resolve();
              }
            }
          });
      });
    },
    checkLoginStatus() {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toacheckstatuslogincustomer",
            {
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
              params: {
                userid: this.$store.state.userid,
                apptype: this.query.apptype,
                pageid: vm.query.pageid,
              },
            }
          )
          .then(async (response) => {
            if (response.data.responsecode == 400) {
              resolve();
            } else {
              await vm.$swal.fire({
                text: "คุณเข้าสู่ระบบเรียบร้อยแล้ว",
              });
              if (this.query.apptype == "line") {
                await this.$liff.closeWindow();
              } else if (this.query.apptype == "facebook") {
                this.$store.dispatch("messengerClose");
              }
              resolve();
            }
          });
      });
    },
    onSelectAddress(address) {
      this.input.sub_district = address.district;
      this.input.district = address.amphoe;
      this.input.province = address.province;
      this.input.zip_code = address.zipcode;
    },

    async getForm() {
      return new Promise((resolve) => {
        axios
          .get("https://communitybotbyzwizai.herokuapp.com/toapainterinfo", {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
            params: {
              userid: this.$store.state.userid,
              apptype: this.query.apptype,
              pageid: this.query.pageid,
            },
          })
          .then(async (response) => {
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
                confirmButtonText: "ตกลง",
              });
              return;
            } else if (response.data.responsecode == 200) {
              Object.assign(this.input, response.data.data[0]);
            }
            resolve();
          });
      });
    },
    async confirmForm() {
      if (!this.saveloading) {
        var vm = this;
        var isValid = await this.$refs.observer.validate();
        if (!this.input.experience.length)
          this.experienceerror = "กรุณาเลือกทักษะที่สามารถรับงานได้";
        if (isValid && this.input.experience) {
          vm.saveloading = true;
          axios
            .post(
              "https://communitybotbyzwizai.herokuapp.com/toaregisterpainter",
              {
                ...this.input,
                userid: this.$store.state.userid,
                apptype: this.query.apptype,
                pageid: this.query.pageid,
                email: vm.removeHiddenSpace(vm.input.email),
              },
              { headers: { AUTHORIZATION: "Bearer xxx xxx" } }
            )
            .then(async (response) => {
              vm.saveloading = false;
              if (response.data && response.data.responsecode == 400) {
                await this.$swal.fire({
                  icon: "error",
                  text: response.data.reason,
                });
                return;
              } else if (response.data.responsecode == 200) {
                //   this.$store.state.orderid = response.data.data[0].orderid;
                await this.$swal.fire({
                  icon: "success",
                  text: "สำเร็จ",
                  confirmButtonText: "ตกลง",
                });
                if (this.query.apptype == "line") {
                  await this.$liff.closeWindow();
                } else if (this.query.apptype == "facebook") {
                  this.$store.dispatch("messengerClose");
                }
                //   this.query.view = "SelectPainter";
              } else if (response.data.responsecode == 401) {
                await vm.$swal.fire({
                  icon: "error",
                  text: response.data.reason,
                });
                vm.query.view = "Login";
                vm.$store.state.redirect = "PainterForm";
              }
            });
        }
      }
    },
  },
  watch: {
    experienceinput(newValue, oldValue) {
      if (newValue && newValue.length) this.experienceerror = "";
    },
  },
};
</script>

<style lang="scss">
.radiotype label {
  font-size: 13px;
}
.smallCheckbox .v-icon {
  font-size: 17px !important;
}
.smallCheckbox .v-label.theme--light {
  font-size: 12px !important;
}
.smallCheckbox .v-input--selection-controls__input {
  margin-right: 2px !important;
}
.smallCheckbox
  .v-input.v-input--hide-details.theme--light.v-input--selection-controls.v-input--checkbox {
  margin-top: 0px !important;
  padding-top: 0px;
  margin-right: 5px !important;
}
</style>